export const databaseResourceTypeMap: Record<string, string> = {
  'e2256bc0-727d-4269-b2be-c4e220480a1a': 'db1',
  '3c349379-cd2f-42ee-961b-cf6cb36b88b2': 'db2',
  '53266eff-2525-4ac8-bbc1-1c8b5bb8f330': 'db3',
  '82f7b586-92df-47c6-a4bc-ab2b6db7c6da': 'db4',
  'acc68598-7497-4bce-bd03-61aa127fbd28': 'db5',
  '8fae20f1-bc48-4cbd-8322-96029c34240a': 'db6',
  'cf37140d-a062-49fd-844c-45800ac601df': 'db7',
  '5f53cad9-91ae-4244-a40d-616d53dbd669': 'db8',
  '2366066d-3f9c-4c81-b507-b7773c55bafe': 'db9',
}
